import { QuotationRequestDto } from '../model/business/calculation/QuotationRequestDto';
import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { RequestOptions } from '../model/RequestOptions';
import { CalculationRequestDto } from '../model/business/CalculationRequestDto';
import { CalculationResponseDto } from '../model/business/calculation/CalculationResponseDto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CalculationApiService {
  constructor(private httpService: HttpService) { }

  requestCalculation(
    model: CalculationRequestDto
  ): Observable<CalculationResponseDto> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    requestOptions.HandleGenericError = true;

    return this.httpService.post<CalculationResponseDto>(
      'calculate',
      model,
      null,
      requestOptions
    );
  }

  getQuotation(quotationRequestDto: QuotationRequestDto): Observable<any> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    requestOptions.ShowSuccess = true;
    requestOptions.HandleGenericError = true;

    return this.httpService.post<any>(
      'quotation/getQuotation',
      quotationRequestDto,
      requestOptions
    );
  }
}
